import { useQuery } from '@tanstack/react-query';
import { orderTrackingModule } from '../api/modules/orderTracking.module';

const CONFIRMED = new Set(['paid', 'delivered']);
const TERMINAL = new Set([
  'paid',
  'delivered',
  'expired',
  'cancelled',
  'refunded',
  'cancelled_refunded',
]);

// Polls GET /api/orders/{id}/status/ every 2s until a terminal status or the
// caller gives up (see PaymentSuccess's ~60s budget). Never assumes success —
// the success page only claims a confirmed payment once `isConfirmed` is true.
export function useOrderStatus(orderId) {
  const query = useQuery({
    queryKey: ['order-status', orderId],
    queryFn: () => orderTrackingModule.getOrderStatus(orderId),
    enabled: !!orderId,
    refetchInterval: (q) => {
      const s = q.state.data?.status;
      return s && TERMINAL.has(s) ? false : 2000;
    },
    retry: false,
  });

  const orderStatus = query.data?.status;

  return {
    ...query,
    status: orderStatus,
    isConfirmed: !!orderStatus && CONFIRMED.has(orderStatus),
    isTerminal: !!orderStatus && TERMINAL.has(orderStatus),
  };
}
